<template>
  <div>
  <p><i class="fas fa-sync fa-spin"></i> Reseting password</p>
  </div>
</template>
<script>
import axios from 'axios'

export default {
  name: 'PasswordReset',
  beforeCreate () {
    let url = '/user/resetPassword?email=' + this.$route.query.email +
      '&time=' + this.$route.query.time + '&signature=' + this.$route.query.signature
    axios.get(url).then(response => {
      console.log(response)
      this.$router.push({ name: 'login' })
    }).catch((error) => {
      console.info(error)
      this.boxOne = ''
      this.$bvModal.msgBoxOk('Something went wrong. Please try again.', {
        okVariant: 'danger'
      })
        .then(value => {
          this.boxOne = value
          if (this.boxOne) {
          } else {
          }
        })
        .catch(error => {
          alert('An error occurred! Please refresh the page.' + error)
        })
    })
  }
}
</script>
<style scoped></style>



// WEBPACK FOOTER //
// src/views/PasswordReset.vue